export default __webpack_public_path__ + "static/media/Requiem of Pain.d79b7730.jpg";